class ScrollService {

    onMissionClick(ref) {
        ref.current?.scrollIntoView({ behavior: 'smooth' });
    } 
}

export default ScrollService;